import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from 'lodash/fp';
import { contentIcons, searchTileType, cpdCategoryType } from '../constants';
import placeholderImage from '../images/placeholders/card03.png';
import { findCpdCategory } from './areas-of-advice';
import { findPublisher } from './publisher';

export const mapRecommendedContent = (cpdCategories, publishers, business = {}, bookmarks = undefined) =>
  fp.flow(
    fp.map((content) => {
      const contentCpdCategoriesIncluded = fp.flow(
        fp.get('cpdCategorys'),
        fp.filter(
          ({ cpdCategoryId }) => fp.find(
            ({ id }) => id === cpdCategoryId
          )(cpdCategories)
        )
      )(content)

      const contentCpdCategoryPoints = cpdCategories 
        ? fp.map(
            ({ cpdCategoryId, points }) => {
              const cpdCategory = findCpdCategory(cpdCategoryId)(cpdCategories)
              return {
                ...cpdCategory,
                points
              }
            }
          )(contentCpdCategoriesIncluded)
        : null;

      const coreCpdPoints = fp.flow(
        fp.filter(({ categoryType }) => categoryType === cpdCategoryType.core),
        fp.sumBy('points')
      )(contentCpdCategoryPoints)

      const isBookmarked = bookmarks === undefined 
        ? undefined
        : bookmarks.map(({ contentId }) => contentId).includes(content.id);

      return ({
        ...content,
        cpdCategorys: contentCpdCategoryPoints,
        points: coreCpdPoints,
        publisher: publishers ?
          findPublisher(content.publisherId)(publishers) :
          null,
        isBookmarked,
      })
    }),
    fp.map((content) => ({
      type: searchTileType.Content,
      id: content.id,
      businessId: content.businessId,
      publisherId: content.publisherId,
      fullCpdCategory: fp.map(({ categoryType, name, points, id }) => ({
        name: he.decode(name),
        points,
        cpdCategoryId: id,
        categoryType
      }))(content.cpdCategorys),
      cpdCategoryId: fp.flow(
        fp.get('cpdCategorys'),
        (cpdCategorys) => {
          return (cpdCategorys.length === 0) ?
            'None' :
            (cpdCategorys.length === 1) ?
              fp.get('id')(fp.first(cpdCategorys)) :
              'Multiple'
        }
      )(content),
      category: cpdCategories ?
        (content.cpdCategorys.length === 0) ?
          'None' :
          (content.cpdCategorys.length === 1) ?
            he.decode(fp.get('name')(fp.first(content.cpdCategorys))) :
            'Multiple' :
        'Unknown',
      icon: fp.get(content.contentType, contentIcons),
      publisher: content.publisher ? he.decode(content.publisher.name) :
        content.businessId && content.businessId === business.id ? he.decode(business.name) : 'Unknown',
      cpdPoints: content.points,
      altText: content.title ? he.decode(content.title) : 'Unknown',
      title: content.title ? he.decode(content.title) : 'Unknown',
      description: content.description ? he.decode(content.description) : 'Unknown',
      duration: dateFnsCompat.distanceInWordsToNow(dateFnsCompat.addMinutes(new Date(), content.estimatedReadingTime)),
      image: content.businessId && content.businessId === business.id ? (business.businessImageUrl ? he.decode(business.businessImageUrl) : placeholderImage) : (content.previewImageUrl ? he.decode(content.previewImageUrl) : placeholderImage),
      completionStatus: content.userContentCompletionStatus,
      selected: content.selected,
      isTasaCpd: content.isTasaCpd,
      status: content.status,
      searchTileId: content.searchTileId,
      goals: content.goals,
      expiryDate: content.expiryDate,
      isBookmarked: content.isBookmarked,
    }))
  );



// WEBPACK FOOTER //
// ./src/services/content.js